import { render, staticRenderFns } from "./bingWechat.vue?vue&type=template&id=36a20f30&scoped=true&"
import script from "./bingWechat.vue?vue&type=script&lang=js&"
export * from "./bingWechat.vue?vue&type=script&lang=js&"
import style0 from "./bingWechat.vue?vue&type=style&index=0&id=36a20f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a20f30",
  null
  
)

export default component.exports